import * as signalR from "@microsoft/signalr";

export const createTrackingHubConnection = () => {
  const hubUrl = `${process.env.REACT_APP_API_BASE_URL}/hubs/tracking`;

  return new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, { withCredentials: true })
    .withAutomaticReconnect()
    .build();
};
